/* eslint-disable */
/**
 * Neptune TP API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrainingProgramSessionQuizStateDto
 */
export interface TrainingProgramSessionQuizStateDto {
    /**
     * 
     * @type {string}
     * @memberof TrainingProgramSessionQuizStateDto
     */
    quizId: string;
    /**
     * 
     * @type {number}
     * @memberof TrainingProgramSessionQuizStateDto
     */
    quizVersion: number;
    /**
     * 
     * @type {{ [key: string]: Array<number>; }}
     * @memberof TrainingProgramSessionQuizStateDto
     */
    quizQuestionAnswerValues: { [key: string]: Array<number>; };
    /**
     * 
     * @type {string}
     * @memberof TrainingProgramSessionQuizStateDto
     */
    beganAt: string;
    /**
     * 
     * @type {string}
     * @memberof TrainingProgramSessionQuizStateDto
     */
    completedAt?: string | null;
}

export function TrainingProgramSessionQuizStateDtoFromJSON(json: any): TrainingProgramSessionQuizStateDto {
    return {
        'quizId': json['quizId'],
        'quizVersion': json['quizVersion'],
        'quizQuestionAnswerValues': json['quizQuestionAnswerValues'],
        'beganAt': json['beganAt'],
        'completedAt': !exists(json, 'completedAt') ? undefined : json['completedAt'],
    };
}

export function TrainingProgramSessionQuizStateDtoToJSON(value?: TrainingProgramSessionQuizStateDto | null): any {
    if (value == undefined) {
        return undefined;
    }
    return {
        'quizId': value.quizId,
        'quizVersion': value.quizVersion,
        'quizQuestionAnswerValues': value.quizQuestionAnswerValues,
        'beganAt': value.beganAt,
        'completedAt': value.completedAt,
    };
}


